<template>
  <BaseEntityBadge
    v-if="column.cellType === 'entity' && row[column.key]"
    :initials="cellValue.initials"
    :name="cellValue.name"
    :meta="cellValue.meta"
  />
  <BaseStatusPill
    v-else-if="column.cellType === 'status' && row[column.key]"
    :label="cellValue.label"
    :variant="cellValue.variant"
  />
  <BaseStatusProgress
    v-else-if="column.cellType === 'progress' && row[column.key]"
    v-bind="cellValue"
    dense
  />
  <BasePerformanceCell
    v-else-if="column.cellType === 'performance' && row[column.key]"
    v-bind="cellValue"
  />
  <BaseRateCell
    v-else-if="column.cellType === 'rate' && row[column.key]"
    v-bind="cellValue"
  />
  <BaseButtonAction
    v-else-if="column.cellType === 'row_action' && row[column.key]"
    v-bind="cellValue"
    :color="cellValue.color || 'primary'"
    :type="cellValue.type || 'text'"
    :size="cellValue.size || 'small'"
    @click.native="$emit('action', { action: cellValue, row })"
  />
  <span
    v-else-if="column.cellType === 'detail_drawer' && row[column.key]"
    class="dashboard-table-cell__detail"
    @click="$emit('detail', row)"
  >
    →
  </span>
  <span v-else>
    <slot>
      {{ row[column.key] }}
    </slot>
  </span>
</template>

<script>
import BaseEntityBadge from './BaseEntityBadge.vue'
import BaseStatusPill from './BaseStatusPill.vue'
import BaseStatusProgress from './BaseStatusProgress.vue'
import BasePerformanceCell from './BasePerformanceCell.vue'
import BaseRateCell from './BaseRateCell.vue'
import BaseButtonAction from './BaseButtonAction.vue'

export default {
  name: 'BaseDashboardTableCell',
  components: { BaseEntityBadge, BaseStatusPill, BaseStatusProgress, BasePerformanceCell, BaseRateCell, BaseButtonAction },
  props: {
    column: {
      type: Object,
      required: true
    },
    row: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    cellValue() {
      return this.row[this.column.key] || {}
    }
  }
}
</script>

<style lang="scss">
.dashboard-table-cell {
  &__detail {
    color: var(--ds-color-black-040);
    cursor: pointer;

    &:hover {
      color: var(--ds-color-black-055);
    }
  }
}
</style>
